import { API_BASE_URL } from '../../config/api';
import apiCache, { CACHE_TTL } from '../../lib/apiCache';

const CACHE_KEY = 'giraAmateur';

const GiraAmaData = {
    fetch: async () => {
        const cached = apiCache.get(CACHE_KEY);
        if (cached !== undefined) return cached;

        try {
            const response = await fetch(`${API_BASE_URL}/api/giraamateur`);
            const data = await response.json();

            if (data.message === "No hay giras vigentes") {
                return apiCache.set(CACHE_KEY, data, CACHE_TTL.LIST);
            }

            // If data is a single object, wrap it in an array
            const giraArray = Array.isArray(data) ? data : [data];
            
            const result = giraArray.map(gira => ({
                gira: gira.gira,
                etapas: gira.etapas,
                nombre: gira.nombre,
                inicio: gira.inicio,
                fin: gira.fin,
                insinicio: gira.insinicio,
                insfin: gira.insfin,
                importe1: gira.importe1,
                importe2: gira.importe2,
                importe3: gira.importe3,
                importe4: gira.importe4,
                codigo: gira.codigo,
                sexo: gira.sexo,
                tipo: gira.tipo,
                insactual: gira.insactual,
                insmaximo: gira.insmaximo,
                foto: gira.foto,
                lastCodigo: gira.lastcodigo,
            }));
            return apiCache.set(CACHE_KEY, result, CACHE_TTL.LIST);
        } catch (error) {
            console.error('Error fetching amateur gira data:', error);
            return { message: "No hay giras vigentes" };
        }
    },
};

export default GiraAmaData;
